module.exports = __webpack_public_path__ + "static/media/galerija_2022_0039.008cbd41.jpg";